import React from "react";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";
import { formatPrice } from "../util";
import qs from "qs";

import config from "../config";

import connectToStores from "alt-utils/lib/connectToStores";
import ItemBucketActions from "../actions/ItemBucketActions";
import ItemBucketStore from "../stores/ItemBucketStore";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class ItemBuckets extends React.Component {
  constructor(props) {
    super(props);
    this._makeRowForItemBucket = this._makeRowForItemBucket.bind(this);
  }

  static getStores() {
    return [ItemBucketStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getItemBucketsForEventBucket:
        ItemBucketStore.getItemBucketsForEventBucket,
      isFetching: ItemBucketStore.getState().isFetching,
      apiKey: UserStore.getState().apiKey
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  _makeCsvLink() {
    let query = {
      god_become_user: UserStore.isGod()
        ? UserStore.getGodCredentials().activeUser
        : undefined,
      api_key: this.props.apiKey
    };

    return `${config.endpoint}event_buckets/${
      this.props.params.eventBucketId
    }/items.csv?${qs.stringify(query)}`;
  }

  _makeRowForItemBucket(itemBucket) {
    return (
      <Tr key={itemBucket.id}>
        <Td column="Name" value={itemBucket.name}>
          {itemBucket.name}
        </Td>
        <Td
          column="Variants"
          value={itemBucket.variants.map(v => v.name).join(", ")}
        >
          {itemBucket.variants.map(v => v.name).join(", ") || "n/a"}
        </Td>
        <Td column="Actions">
          <div>
            <Link
              to={{
                pathname: `/event_buckets/${this.props.params.eventBucketId}/item_buckets/${itemBucket.id}`,
                state: { fromListing: true }
              }}
            >
              View
            </Link>
            &nbsp;
            <Link
              to={{
                pathname: `/event_buckets/${this.props.params.eventBucketId}/item_buckets/${itemBucket.id}/edit`,
                state: { fromListing: true }
              }}
            >
              Settings
            </Link>
          </div>
        </Td>
      </Tr>
    );
  }

  componentWillMount() {
    ItemBucketActions.fetchAllForEventBucket(this.props.params.eventBucketId);
  }

  render() {
    let styles = this.getStyles(),
      itemBuckets = this.props.getItemBucketsForEventBucket(
        this.props.params.eventBucketId
      ),
      rows = itemBuckets.map(this._makeRowForItemBucket);

    if (itemBuckets.length === 0 && ItemBucketStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          sortable={[
            { column: "Name", sortFunction: Sort.CaseInsensitive },
            "Variants"
          ]}
          defaultSort={{ column: "Name", direction: "asc" }}
          columns={["Name", "Variants", "Actions"]}
          filterable={["Name", "Variants"]}
          filterPlaceholder="Type to filter..."
        >
          {rows}
        </Table>
        {rows.length === 0 ? (
          <div className="empty-table-message">
            No item buckets yet.{" "}
            <Link
              to={`/event_buckets/${this.props.params.eventBucketId}/item_buckets/new`}
            >
              Create a new item bucket.
            </Link>
          </div>
        ) : null}
        <div style={{ marginTop: 20 }}>
          <RaisedButton
            label="Create new item bucket"
            primary={true}
            onTouchTap={() =>
              this.context.router.push(
                `/event_buckets/${this.props.params.eventBucketId}/item_buckets/new`
              )
            }
          />
          {/*<RaisedButton style={{marginLeft: 7, verticalAlign: 'top'}} href={this._makeCsvLink()} target="_blank" label="Download all items (.csv)" />*/}
        </div>
      </div>
    );
  }
}

export default connectToStores(ItemBuckets);



// WEBPACK FOOTER //
// ./src/app/components/item-buckets.jsx